import {
  Component,
  computed,
  inject,
  input,
  resource,
  signal,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SimpleApi } from '@core/api/simple.api';
import { KonverteringUdtraek } from '../konvertering-udtraek.model';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-konvertering-datagrid',
  imports: [TableModule],
  templateUrl: './konvertering-datagrid.component.html',
  styleUrl: './konvertering-datagrid.component.css',
})
export class KonverteringDatagridComponent {
  data = input.required<any[]>();

  cols = computed(() => {
    if (this.data().length == 0) return [];
    const firstRow = this.data()[0];
    const fields = Object.keys(firstRow);
    return fields.map(x => ({ field: x, header: x }));
  });
}
